import cn from 'classnames';
import { useWatch } from 'react-hook-form';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useIsComponentMounted } from '../../../../../../../hooks';
import { useRootSelector } from '../../../../../../../store/hooks';
import { selectSitePricingProductsData } from '../../../../../store/features/products';
import Tabs, { TabsProps } from '../../../../../shared/library/Tabs';
import Typography from '../../../../../shared/library/Typography';
import Tooltip from '../../../../../shared/library/Tooltip';
import Tab from '../../../../../shared/library/Tab';
import { StyledInfoIcon } from './styles';

export interface HorizontalTabsProps extends TabsProps {}

export default function HorizontalTabs(props: HorizontalTabsProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isMounted = useIsComponentMounted();

  const activeDelegateTypeId = useWatch({
    name: 'delegateTypeId',
  });

  const { delegateTypes } = useRootSelector(selectSitePricingProductsData);

  return (
    <Tabs
      defaultValue={delegateTypes[0]?.delegateTypeId}
      orientation={isMobile ? 'vertical' : 'horizontal'}
      variant={isMobile ? 'standard' : 'fullWidth'}
      {...props}
      className={cn(props.className, 'informa-payment-delegates-horizontal')}
    >
      {delegateTypes.map((delegate) => {
        const isActiveTab = activeDelegateTypeId === delegate.delegateTypeId;

        const label = (
          <Typography
            variant="h5"
            neutralColorIndex={isActiveTab ? 800 : 600}
            component="span"
            className="informa-payment-delegates-horizontal__name"
          >
            {delegate.name}
          </Typography>
        );
        const infoIcon =
          isMounted && delegate.description ? (
            <Tooltip title={delegate.description}>
              <StyledInfoIcon fontSize="small" />
            </Tooltip>
          ) : undefined;

        return (
          <Tab
            value={delegate.delegateTypeId}
            label={label}
            icon={infoIcon}
            iconPosition="end"
            key={delegate.delegateTypeId}
          />
        );
      })}
    </Tabs>
  );
}
